import {forwardRef, HTMLAttributes} from 'react';
import {twMerge} from 'tailwind-merge';

import {chain} from './styles.module.css';

type ChainProps = HTMLAttributes<HTMLDivElement>;

const Chain = forwardRef<HTMLDivElement, ChainProps>(
    ({children, className, ...props}, ref) => (
        <div
            className={twMerge(chain, className)}
            ref={ref}
            role="group"
            {...props}
        >
            {children}
        </div>
    ),
);
Chain.displayName = 'Chain';

export default Chain;
